import React from "react";
import MovieListSection from "./MovieListSection";
import Topsection from "./Topsection";
const Home = () => {
  return (
    <>
      <Topsection />
      <MovieListSection />
    </>
  );
};

export default Home;
